module.exports = __webpack_public_path__ + "img/logo-icon.32ee125a.png";